import { parseVersion } from '@amzn/vinyl-util'

export const bullfrogVersion = parseVersion(process.env.BULLFROG_VERSION ?? '0.0.0.0')
;(global as any).version = bullfrogVersion.str
